import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { PageParams } from 'src/app/core/models/page-params.model';
import { ISaleOrder } from '../../../models/sale-order.interface';
import { SaleOrderService } from '../../../services/sale-order.service';
import { DetailsPopupComponent } from './details-popup/details-popup.component';

@Component({
  selector: 'eci-update-history',
  templateUrl: './update-history.component.html',
  styleUrls: ['./update-history.component.scss']
})
export class UpdateHistoryComponent implements OnInit, OnChanges {

  pageParams: PageParams = new PageParams();

  @Input() info: ISaleOrder;
  @Input() availableTypes: any;

  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  isB2BSaleOrder: boolean = false;

  pageChanged(e: PageParams): void {
    this.pageParams.pageIndex = e.pageIndex;
    this.pageParams.pageSize = e.pageSize;
    // this.getList(e.pageIndex + 1, e.pageSize);
  }
  
  constructor(
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    if (!this.info) return;

    this.dataSource = new MatTableDataSource<any>(this.info.saleOrderHistory);
    this.isB2BSaleOrder = !!this.info.isB2B;
  }

  ngOnChanges(): void {
    if (!this.info) return;

    this.dataSource = new MatTableDataSource<any>(this.info.saleOrderHistory);
  }

  displayedColumns: string[] = [
    'rowDate',
    'marketplaceOrderId',
    'referenceOrderId',
    'status',
    'view',
  ];

  openDetails(index): void {
    const dialogRef = this.dialog.open(DetailsPopupComponent);
    dialogRef.componentInstance.data = this.dataSource.data[index];
    dialogRef.componentInstance.isB2BSaleOrder = this.isB2BSaleOrder;
  }
}
